export const REGEXPS = {
  emailValidator: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}$/,
  blikValidator: /^[0-9 ]{7}$/,
}
